@if (source) {
  <div class="relative w-full h-full">
    @switch (mediaPreviewType()) {
      @case ('image') {
        <nrc-image
          class="w-full h-full"
          [objectFit]="objectFit"
          [isTransparent]="true"
          [source]="{ uri: source, mimetype }"
          [thumbnail]="thumbnailSource ? { uri: thumbnailSource, mimetype } : undefined"
          (loadComplete)="onMediaLoadComplete()"
        />
      }
      @case ('video') {
        <nrc-video
          class="w-full h-full"
          [sources]="[{ uri: source, mimetype }]"
          [isRounded]="false"
          [autoplay]="autoplay"
          [objectFit]="objectFit"
          (loadComplete)="onMediaLoadComplete()"
          (videoPlayEvent)="onVideoPlay($event)"
          (videoEndEvent)="onVideoEnded()"
          (videoPauseEvent)="onVideoPaused($event)"
          (videoSeekEvent)="onVideoSeeked($event)"
          (videoDuration)="onVideoDuration($event)"
        />
      }
      @case ('video-snippet') {
        <nrc-video
          class="w-full h-full"
          [sources]="[{ uri: source, mimetype }]"
          [isRounded]="false"
          [autoplay]="true"
          [loop]="true"
          [controls]="false"
          [muted]="true"
          [playsInline]="true"
          [disablePictureInPicture]="true"
          [objectFit]="objectFit"
          (loadComplete)="onMediaLoadComplete()"
          (videoPlayEvent)="onVideoPlay($event)"
          (videoEndEvent)="onVideoEnded()"
          (videoPauseEvent)="onVideoPaused($event)"
          (videoSeekEvent)="onVideoSeeked($event)"
          (videoDuration)="onVideoDuration($event)"
        />
      }
      @case ('audio') {
        <nrc-audio
          class="w-full h-full"
          [sources]="[{ uri: source, mimetype }]"
          (loadComplete)="onMediaLoadComplete()"
        />
      }
      @default {
        <nrc-file-type
          class="flex items-center justify-center w-full h-full rounded-md grow"
          nrcAspectRatio
          [nrcAspectRatioBasedOn]="'height'"
          [mimetype]="mimetype"
          [classList]="classList"
          [iconColor]="'white'"
        />
      }
    }
  </div>
} @else {
  <nrc-file-type
    class="flex items-center justify-center w-full h-full grow"
    nrcAspectRatio
    [nrcAspectRatioBasedOn]="'height'"
    [mimetype]="mimetype"
    [classList]="classList"
    [iconColor]="'white'"
  />
}
